import { type ReactElement } from 'react';

const PulseIcon = (): ReactElement => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0476 5.74875C12.4229 4.23093 14.5795 4.22775 14.959 5.74436L17.625 16.4077L18.6306 12.386C18.7976 11.7183 19.3977 11.25 20.0859 11.25H21.75C22.1642 11.25 22.5 11.5858 22.5 12C22.5 12.4142 22.1642 12.75 21.75 12.75H20.0859L19.0803 16.7717C18.7015 18.2864 16.5485 18.2863 16.1697 16.7717L13.5044 6.10837L12.1238 11.6909C11.9536 12.3784 11.3258 12.8533 10.6179 12.8298L8.83081 12.7698L7.83032 16.7717C7.45146 18.2863 5.29854 18.2863 4.91968 16.7717L3.91406 12.75H2.25C1.83579 12.75 1.5 12.4142 1.5 12C1.5 11.5858 1.83579 11.25 2.25 11.25H3.91406C4.60228 11.25 5.20236 11.7183 5.36938 12.386L6.375 16.4077L7.37549 12.4057C7.54707 11.72 8.17413 11.2469 8.88062 11.2705L10.6677 11.3305L12.0476 5.74875Z"
      fill="currentColor"
    />
  </svg>
);

export default PulseIcon;
